// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top p[data-v-5bc07c7e]{text-align:center;margin:0;padding:10px 0 0}.right h4[data-v-5bc07c7e]{margin:15px 0 5px}.left p[data-v-5bc07c7e],.right p[data-v-5bc07c7e]{font-size:14px;margin:5px 0 15px}[data-v-5bc07c7e]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
